/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Complete address
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * address supplement if needed
     * @type {string}
     * @memberof Address
     */
    supplement?: string;
    /**
     * the name of the street in the address
     * @type {string}
     * @memberof Address
     */
    street?: string;
    /**
     * the locality in the address
     * @type {string}
     * @memberof Address
     */
    locality?: string;
    /**
     * the postal code in the address
     * @type {string}
     * @memberof Address
     */
    postalCode?: string;
    /**
     * the prefix of postal code in the address
     * @type {string}
     * @memberof Address
     */
    postalCodePrefix?: string;
    /**
     * the code iso of the country
     * @type {string}
     * @memberof Address
     */
    isoCode?: string;
    /**
     * the name of the country
     * @type {string}
     * @memberof Address
     */
    country?: string;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): value is Address {
    return true;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if (json == null) {
        return json;
    }
    return {
        
        'supplement': json['supplement'] == null ? undefined : json['supplement'],
        'street': json['street'] == null ? undefined : json['street'],
        'locality': json['locality'] == null ? undefined : json['locality'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'postalCodePrefix': json['postalCodePrefix'] == null ? undefined : json['postalCodePrefix'],
        'isoCode': json['isoCode'] == null ? undefined : json['isoCode'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function AddressToJSON(json: any): Address {
    return AddressToJSONTyped(json, false);
}

export function AddressToJSONTyped(value?: Address | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'supplement': value['supplement'],
        'street': value['street'],
        'locality': value['locality'],
        'postalCode': value['postalCode'],
        'postalCodePrefix': value['postalCodePrefix'],
        'isoCode': value['isoCode'],
        'country': value['country'],
    };
}

